// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"512":"ee8e0e4b","675":"f763dd97","749":"e1d1e89c","903":"42332a30"}[chunkId] + ".chunk.js";
};